import { render, staticRenderFns } from "./MathSubPackSvg.vue?vue&type=template&id=139e604e&"
import script from "./MathSubPackSvg.vue?vue&type=script&lang=ts&"
export * from "./MathSubPackSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('139e604e', component.options)
    } else {
      api.reload('139e604e', component.options)
    }
    module.hot.accept("./MathSubPackSvg.vue?vue&type=template&id=139e604e&", function () {
      api.rerender('139e604e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/MathSubPackSvg.vue"
export default component.exports